export const INVOICE_TERM_DAYS = { "On receipt": 0, "Net 15": 15, "Net 30": 30, "Net 45": 45, "Net 60": 60 } as const;
export type InvoiceRelativeTerm = keyof typeof INVOICE_TERM_DAYS;
export type InvoiceTerm = InvoiceRelativeTerm | "Custom";
export type InvoiceDueDateProvenance = "derived_net_0" | "derived_net_15" | "derived_net_30" | "derived_net_45" | "derived_net_60" | "manual";

export function addInvoiceDays(issueDate: string, days: number): string {
  const date = new Date(`${issueDate}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function termForInvoiceDueDate(issueDate: string, dueDate: string): InvoiceTerm {
  return (Object.entries(INVOICE_TERM_DAYS) as [InvoiceRelativeTerm, number][]).find(([, days]) => addInvoiceDays(issueDate, days) === dueDate)?.[0] ?? "Custom";
}

export function invoiceDueDateProvenance(term: InvoiceTerm): InvoiceDueDateProvenance {
  return term === "Custom" ? "manual" : `derived_net_${INVOICE_TERM_DAYS[term]}` as InvoiceDueDateProvenance;
}
